import { Text, View, hexColor } from "@lightningtv/solid";
import { Show, createEffect, createSignal } from "solid-js";
import { t } from "../../../translations/configuration";

// Same data-card language as Account.tsx: subtle radius, dark surface,
// white outline + slight scale on focus.
const DataCard = (props: { label: string; value: string; width?: number }) => (
  <View
    style={{
      width: props.width ?? 380,
      height: 110,
      scale: 1,
      borderRadius: 10,
      color: hexColor("#1C1C1E"),
      border: { width: 0, color: hexColor("#00000000") },
      transition: {
        scale: { duration: 200, easing: "ease-in-out" },
        border: { duration: 150 },
      },
      focus: {
        scale: 1.04,
        border: { width: 3, color: hexColor("#ffffff") },
      },
    }}
  >
    <View
      x={22}
      y={22}
      style={{ display: "flex", flexDirection: "column", gap: 8, width: (props.width ?? 380) - 44 }}
    >
      <Text style={{ fontSize: 20, color: hexColor("#8E8E93") }}>{props.label}</Text>
      <Text
        contain="width"
        style={{
          fontSize: 26,
          color: hexColor("#ffffff"),
          maxLines: 1,
          width: (props.width ?? 380) - 44,
        }}
      >
        {props.value}
      </Text>
    </View>
  </View>
);

const Subscriptions = (props: any) => {
  const [data, setData] = createSignal(null);
  const [packageName, setPackageName] = createSignal(null);
  createEffect(() => {
    const storedData = localStorage.getItem("licenceData");
    if (storedData) {
      try {
        // Parse the JSON string into an object
        const parsedData = JSON.parse(storedData);
        setData(parsedData);
      } catch (error) {
        console.error("Failed to parse storedData:", error);
      }
    }
  });
  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      // timeZoneName: 'short'
    });
  }
  return (
    <View ref={props.ref} x={600} y={400} height={400} width={2000} clipping>
      <Text style={{ fontSize: 40, fontWeight: "bold", color: hexColor("#ffffff") }}>{t("subscriptions")}</Text>

      {/* Dynamic card grid, same as Account.tsx — a card only appears when
          there's data for it, and cards flow left-to-right with a gap */}
      <View
        y={90}
        style={{ display: "flex", flexDirection: "row", gap: 24, width: 1200 }}
      >
        <Show when={data() && data().package_name}>
          <DataCard label={t("packName")} value={data().package_name} />
        </Show>

        <Show when={data() && data().license_end_date}>
          <DataCard label={t("expireDate")} value={formatDate(data().license_end_date)} width={420} />
        </Show>
      </View>
    </View>
  );
};
export default Subscriptions;
